import {Component, Inject, Input, LOCALE_ID, OnInit} from '@angular/core';
import {SubSink} from '@Common/core/utils/subsink';
import {DayEnum, Planning} from '../../suaps/common/services/planning/plannig.model';
import {Campagne} from '../../suaps/common/services/campagne/campagne.model';
import {CampagneService} from '../../suaps/common/services/campagne/campagne.service';
import {Individu, IndividuService, PubSubService} from '@Common/core/services';
import {MenuItems} from '../common/models/menu-items.model';
import {FiltersModel} from '../common/models/filters.model';
import {DatePipe} from '@angular/common';
import {PaginationDirection, PaginationModel} from '../common/models/pagination.model';
import {ListParameters} from '@Services/base/daoService';
import {finalize} from 'rxjs/operators';
import {Pagination} from '@Common/widgets/general/pagination';
import {Interlignage, PoliceNames, style} from '../common/models/style.model';
import {MessageEnum} from '@Common/neo-components/message/message-enum';
import {PlanningFOService} from '../../suaps/common/services/planning/planning-fo.service';

@Component({
  selector: 'app-activities',
  templateUrl: './activities.component.html',
  styleUrls: ['./activities.component.scss'],
})
export class ActivitiesComponent implements OnInit {

  subSink = new SubSink();
  extraParams: Map<string, string> = new Map<string, string>();
  activities: Planning[] = [];
  campagne: Campagne = <Campagne>{id: 0};
  activityDetail: Planning = <Planning>{id: 0};
  connecte: Individu;
  noResults = false;
  noFilteredResults = false;
  nothingMessage = '';
  menuItems: MenuItems = {myActivities: true, filters: true};
  myActivities = false;
  filters: FiltersModel = <FiltersModel>{typeCours: 0, activites: [], jours: [], categorieCours: 3};
  limit = 9;
  pagination: PaginationModel = {previous: null, next: null, limit: this.limit,
    nb_items: 0, start: 1, total: 0, urlBaseOverride: null, paginationDirection: null};
  parameters: ListParameters = <ListParameters>{};
  dayEnum = DayEnum;
  @Input() mainStyle: style = <style>{};
  @Input() interlignage: Interlignage = Interlignage.default;
  @Input() police: PoliceNames = PoliceNames.default;
  messageType = MessageEnum;

  readonly _beforeClosureMessage = 'Nous vous rappelons que les inscriptions ouvriront prochainement, si vous avez des questions vous pouvez vous rendre au bureau des sports.';
  readonly _afterClosureMessage = 'Les inscriptions en ligne sont closes, toutefois vous pouvez vous rendre au bureau des sports et voir les places disponibles dans les activités et vous inscrire à ce moment là.';
  readonly _noCampaign = "Aucune campagne n'est activée";

  constructor(@Inject(LOCALE_ID) private locale: string,
              private planningSvc: PlanningFOService,
              private campagneSvc: CampagneService,
              private individuSvc: IndividuService,
              private pubSvc: PubSubService,) { }

  ngOnInit(): void {
    this.subSink.sink = this.individuSvc.individu$.subscribe((_individu) => this.connecte = _individu);
    this._getEnabledCampagne();
  }

  private _getActivities(): void {
    this.pubSvc.publish('loading', true);
    this._clearPagination();
    this.noFilteredResults = false;
    this.noResults = false;
    this.extraParams.clear();
    this.extraParams.set('campagne', this.campagne.id.toString());
    this.extraParams.set('limit', this.pagination.limit.toString());
    this.extraParams.set('is_active', true.toString());
    this.menuItems = {myActivities: true, filters: true, returnToActivities: false};
    if (this._isFilter()) {
      this._getFilteredActivities();
    } else {
      this.nothingMessage = 'Aucune activité sportive n\'est disponible pour l\'instant...';
      this.subSink.sink = this.planningSvc.listAllItems(this.extraParams)
        .pipe(finalize(() => this.pubSvc.publish('loading', false)))
        .subscribe((_data) => {
          this.activities = _data.list['results'];
          this.pagination.next = _data.list['next'];
          this.pagination.previous = _data.list['previous'];
          this.pagination.total = _data.list['count'];
          this.pagination.nb_items = _data.list['results'].length;
          this.noResults = _data.list['results'].length < 1;
        });
    }

  }

  private _getEnabledCampagne(): void {
    this.extraParams.clear();
    this.extraParams.set('is_active', 'true');
    this.subSink.sink = this.campagneSvc.listAllItems(this.extraParams).subscribe((_data) => {
      this.campagne = _data.list[0];
      if (_data.list[0]) {
        this._getActivities();
      } else {
        this.noResults = true;
      }
    });
  }

  getActivities(event: boolean): void {
    this.myActivities = event;
    if(event){
      this._getMyActivities(event);
    }else{
      this._getActivities();
    }
  }

  _getMyActivities(event: boolean): void {
    this.menuItems = {myActivities: false, filters: false, returnToActivities: true};
    this.pubSvc.publish('loading', true);
    this._clearPagination();
    this.noFilteredResults = false;
    this.noResults = false;
    this.extraParams.clear();
    this.nothingMessage = 'Vous n\'avez pas d\'inscriptions';
    this.subSink.sink = this.planningSvc.getMesInscriptions()
      .pipe(finalize(() => this.pubSvc.publish('loading', false)))
      .subscribe((_data) => {
        this.activities = _data;
        this.noResults = _data.length < 1;
      });

  }

  openDetail(activity: Planning): void {
    this.activityDetail = activity;
  }

  closeDetail(): void {
    this._getActivities();
    this.activityDetail = <Planning>{id: 0};
  }

  setFilters(filters: FiltersModel): void {
    this.filters = filters;
    this._getActivities();
  }

  displaySubscriptionsDate(campagne: Campagne): string {
    if (campagne.date_debut && campagne.date_fin) {
      const datePipe =  new DatePipe(this.locale);
      const dateDebut = datePipe.transform(campagne.date_debut, 'dd/MM/YY HH:mm').toString();
      const dateFin = datePipe.transform(campagne.date_fin, 'dd/MM/YY HH:mm').toString();
      return `Inscriptions ouvertes du ${dateDebut} au ${dateFin}`;
    }
    return 'Dates d\'inscriptions non indiquées pour le moment';
  }

  paginate(pagination: PaginationModel): void {
    this.pubSvc.publish('loading', true);
    this.parameters.urlBaseOverride = pagination.urlBaseOverride;
    this.subSink.sink = this.planningSvc.listItems(this.parameters)
      .pipe(finalize(() => this.pubSvc.publish('loading', false)))
      .subscribe((_data) => {
      this.activities = _data.list['results'];
      this._populatePagination(_data, pagination);
      this.pubSvc.publish('loading', false);
    });
  }

  private _getFilteredActivities(): void {
    this.pubSvc.publish('loading', true);
    this._deleteFilterExtraParams();
    this.nothingMessage = 'Désolé, aucun résultat ne correspond à votre recherche...';
    if (this.filters.typeCours > 0) {
      this.extraParams.set('type_cours', this.filters.typeCours.toString());
    }
    if (this.filters.categorieCours !== 3) {
      const paramCategorieJoursIn = `${this.filters.categorieCours.toString()},3`;
      this.extraParams.set('categorie_cours__in', paramCategorieJoursIn);
    }
    if (this.filters.jours.length > 0) {
      this.filters.jours.push(this.dayEnum.freeAccess.toString());
      this.extraParams.set('jour__in', this.filters.jours.toString());
    }
    if (this.filters.activites.length > 0) {
      this.extraParams.set('activite__in', this.filters.activites.toString());
    }
    this.subSink.sink = this.planningSvc.listAllItems(this.extraParams)
      .pipe(finalize(() => this.pubSvc.publish('loading', false)))
      .subscribe((_data) => {
      this.activities = _data.list['results'];
      this._populatePagination(_data);
      this.noFilteredResults = _data.list['results'].length < 1;
    });
  }

  private _isFilter(): boolean {
    if (this.filters.typeCours > 0 || this.filters.jours.length > 0
      || this.filters.activites.length > 0 || this.filters.categorieCours !== 3) {
      return true;
    }
    return false;
  }

  private _deleteFilterExtraParams(): void {
    this.extraParams.delete('type_cours');
    this.extraParams.delete('jour__in');
    this.extraParams.delete('activite__in');
    this.extraParams.delete('categorie_cours__in');
  }

  private _populatePagination(_data: Pagination, pagination: PaginationModel = null): void {
    this.pagination.next = _data.list['next'];
    this.pagination.previous = _data.list['previous'];
    this.pagination.total = _data.list['count'];
    this.pagination.nb_items = _data.list['results'].length;
    if (pagination) {
      if (pagination.paginationDirection === PaginationDirection.previous) {
        this.pagination.start = pagination.start - pagination.limit;
      } else {
        this.pagination.start = pagination.start + pagination.limit;
      }
    }
  }

  private _clearPagination(): void {
    this.pagination = {previous: null, next: null, limit: this.limit,
      nb_items: 0, start: 1, total: 0, urlBaseOverride: null, paginationDirection: null};
  }

  displayClosedMessage(): string {
    if (this.campagne) {
      const today = new Date();
      const date_debut_inscriptions = new Date(this.campagne.date_debut);
      const date_fin_inscriptions = new Date(this.campagne.date_fin);
      if (today < date_debut_inscriptions) {
        return this._beforeClosureMessage;
      }
      if (today > date_fin_inscriptions) {
        return this._afterClosureMessage;
      }
    } else {
      this.nothingMessage = 'Aucune activité sportive n\'est disponible pour l\'instant...';
      return this._noCampaign;
    }
    return null;
  }
}
